export default __webpack_public_path__ + "static/media/teaMoon.85c8a47f.jpg";